import styled, { css } from 'styled-components';

export const OptionBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 1em;
  margin: 0 1em;
  cursor: pointer;
  background-color: transparent;
  column-gap: 1em;

  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
  `}

  @media (max-width: 768px) {
    margin: 0;
    }
  }
  
  &.marketing-item-selector:hover:not(.disabled) {
    background-color: rgba(0, 0, 0, 0.05);
    transform: none;
    box-shadow: none;
  }

  &.marketing-item-selector.disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }

  &.marketing-item-selector {
    transition: transform 0.2s ease-in-out;
    
    /* Desktop view - horizontal layout (icon beside text) */
    @media (min-width: 769px) {
      flex-direction: row;
      justify-content: flex-start;
      text-align: left;
      align-items: center;
      padding: 0.5em 1em;
      margin: 0;
      height: 100%;
      min-height: 40px;
    }
    
    /* Mobile view - vertical layout */
    @media (max-width: 768px) {
      flex-direction: column;
      justify-content: center;
      text-align: center;
      align-items: center;
      padding: 0;
      margin: 0;
    }
  }
`;

export const SelectedOptionBox = styled(OptionBox)`
  background-color: #e0e0e0;
`;

export const OptionsContainer = styled.div`
  margin: 1em auto;
  max-height: 60vh;
  overflow-y: auto;

  &.marketing-item-grid {
    /* Desktop grid layout - 4 columns with margins */
    @media (min-width: 769px) {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      column-gap: 20px;
      align-items: start;
      width: 95%;
      margin: 25px auto 10px auto;
      padding: 0;
      max-height: 70vh;
    }

    @media (max-width: 768px) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 0;
      max-height: 68vh;
    }

    /* Special styling for exactly 6 items */
    &.six-items {
      @media (min-width: 769px) {
        grid-template-columns: repeat(3, 1fr);
        column-gap: 8px;
        row-gap: 20px;
        padding: 0 50px;
        width: auto;
        margin: 25px 0 10px 0;
      }

      @media (max-width: 768px) {
        gap: 2px;
        margin: 0.1em;
        padding-bottom: 0;
      }

      /* Override for 6-item layout - vertical layout with text below icon */
      .marketing-item-selector {
        @media (min-width: 769px) {
          flex-direction: column;
          justify-content: center;
          text-align: center;
          align-items: center;
          padding: 1em 0.5em;
          min-height: 80px;
        }

        @media (max-width: 768px) {
          padding: 0.1em 0;
        }
      }
    }
  }

  @media (max-width: 768px) {
    margin: 1em;
    padding-bottom: 0;
  }
`;

interface ItemDetailsProps {
  $isSixItemLayout?: boolean;
}

export const ItemDetails = styled.p<ItemDetailsProps>`
  font-size: 18px;
  color: #072c54;
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.regular};
  `}

  @media (max-width: 400px) {
    font-size: 16px;
  }

  @media (min-width: 769px) {
    margin: 0;
    font-size: ${(props) => (props.$isSixItemLayout ? '14px' : '16px')};
    line-height: 1.2;
    ${(props) =>
      props.$isSixItemLayout
        ? css`
            text-align: center;
            word-wrap: break-word;
            hyphens: auto;
          `
        : css`
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          `}
  }
`;

export const Slug = styled.p`
  @media (min-width: 768px) {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    margin-right: 2em;
  }
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.extraLight};
  `}
`;

interface ItemImageProps {
  $isSixItemLayout?: boolean;
}

export const ItemImage = styled.div<ItemImageProps>`
  @media (min-width: 769px) {
    margin: ${(props) => (props.$isSixItemLayout ? '0 0 8px 0' : '0 8px 0 0')};
    width: ${(props) => (props.$isSixItemLayout ? '50px' : '30px')};
    min-width: ${(props) => (props.$isSixItemLayout ? '50px' : '30px')};
    height: ${(props) => (props.$isSixItemLayout ? '50px' : '30px')};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    margin-bottom: ${(props) => (props.$isSixItemLayout ? '0px' : '12px')};
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ItemInfo = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }

  @media (min-width: 769px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    min-width: 0;
  }
`;
